var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.show,"rounded":"sm","no-wrap":"","z-index":11},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center my-2"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","size":_vm.size,"pulse":""}}),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.message)+"...")])])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }